import { render } from "./ImageMarker.vue?vue&type=template&id=20142788"
import script from "./ImageMarker.vue?vue&type=script&lang=js"
export * from "./ImageMarker.vue?vue&type=script&lang=js"

import "./ImageMarker.vue?vue&type=style&index=0&id=20142788&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__